<template>
    <div class="dashboard-container" id="food-app">
      <div class="container">
        <div class="tableBar">
          <el-input
            v-model="input"
            placeholder="请输入管理员名称"
            style="width: 250px;margin-top: 20px"
            clearable
            @keyup.enter="handleQuery"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
              @click="init"
            ></i>
          </el-input>
          <div class="tableLab" style="float: right">
            <!-- <el-button
              type="primary"
              @click="addFoodtype"
              style="margin-top: 20px"
            >
              + 新增管理员
            </el-button> -->
          </div>
        </div>
  
  
  
        <el-table
          :data="tableData"
          stripe
          class="tableBox"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="25"
          ></el-table-column>
          <el-table-column
            prop="id"
            label="管理员ID"
          ></el-table-column>
          <el-table-column
            prop="username"
            label="管理员用户名"
          ></el-table-column>
          <el-table-column
            prop="password"
            label="密码"
          >
          </el-table-column>
          <el-table-column
            prop="username"
            label="真实姓名"
          >
          </el-table-column>
          <el-table-column
            prop="password"
            label="联系电话"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="160"
            align="center"
          >
            <template #default="scope">
              <el-button
                type="text"
                size="small"
                class="blueBug"
                @click="editadmin(scope.row)"
                icon="el-icon-edit"
              >
                修改
              </el-button>
              <!-- <el-button
                type="danger"
                size="small"
                class="delBut non"
                @click="deleteHandle( scope.row.id)"
                icon="el-icon-delete"
              >
                删除
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pageList"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="counts"
          @size-change="handleSizeChange"
          v-model:current-page="page"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
  
  
  <!--    //修改管理员信息表单-->
      <el-dialog title="管理员信息" v-model="dialogTableVisible">
        <el-form label-width="180px" :model="adminmsg">
          <el-form-item label="管理员序号:" style="width: 800px">
            <el-input disabled v-model="adminmsg.id" readonly></el-input>
          </el-form-item>
          <el-form-item label="管理员名称:" style="width: 800px">
            <el-input v-model="adminmsg.username"></el-input>
          </el-form-item>
          <el-form-item label="管理员密码:" style="width: 800px">
            <el-input v-model="adminmsg.password"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="dialogTableVisible = false">取 消</el-button>
      <el-button type="primary" @click="quedingedit(adminmsg)">确 定</el-button>
    </span>
      </el-dialog>
  
  
  
  
  
    </div>
  
  
  </template>
  
  <script>
  import axios from "axios";
  
  
  
  
  
  export default {
    name: 'Manage',
    data() {
      return {
        tableData: [],
        typeNameArr: [],
        pagesize:10,
        page:1,
        input: '',
        counts:0,
        dialogTableVisible:false,
        adminmsg:{
          id:'',
          username:'',
          password:'',
          labelPosition:"left"
        },
        msg:"修改"
      }
    },
  
  
  
    mounted() {
      this.init()
    },
    methods: {
  
  
  
      init(){
        const params = {
          id:this.id,
          page: this.page,
          pagesize: this.pagesize,
          input: this.input ? this.input : undefined
        }
  
  
        axios.get('http://localhost:8090/admin/list',{
            params
          }
        )
          .then(response => {
            this.tableData=response.data.data.records
            // 请求成功时的处理逻辑
            console.log(this.tableData)
  
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      },
  
      //打开修改窗口
      editadmin(data){
     this.adminmsg=data   
        this.dialogTableVisible=!this.dialogTableVisible
  
      },
  
      handleQuery(){
  
      },
  

      //删除这个admin数据
      deleteHandle(data){
        this.$confirm('确认删除该管理员信息,请慎重需再数据库添加, 是否继续?', '确定删除', {
          'confirmButtonText': '确定',
          'cancelButtonText': '取消',
        }).then(()=>{
          axios.delete('http://localhost:8090/admin/deleteAdmin?id='+data.id)
            .then(response => {
              this.$message.success("删除成功")
              this.dialogTableVisible=false
            this.init();
            })
            .catch(error => {
              // 请求失败时的处理逻辑
              console.error(error); // 输出错误信息
            });
        })
      },
  
      //当点击确定的时候
      quedingedit(data){
          let params={
            id:data.id,
            username:data.username,
            password:data.password
          }
          //当点击确认修改的时候，调用后端update方法修改admin表
          this.$confirm('确认确认修改, 是否继续?', '确定修改', {
            'confirmButtonText': '确定',
            'cancelButtonText': '取消',
          }).then(()=>{
            axios.post('http://localhost:8090/admin/update', params
            )
              .then(response => {
                this.dialogTableVisible=!this.dialogTableVisible
                this.$message.success("修改成功")
                this.dialogTableVisible=false
               this.init();
              })
              .catch(error => {
                // 请求失败时的处理逻辑
                console.error(error); // 输出错误信息
              });
          })
       
  
  
  
  
  
      },
  
      //新增管理员信息
      addFoodtype(){
        this.dialogTableVisible=!this.dialogTableVisible
        //修改状态
        this.msg='新增'
  
      },
  
  
  
      // 全部操作
      handleSelectionChange (val){
        let checkArr = []
        val.forEach((n) => {
          checkArr.push(n.id)
        })
        this.checkList = checkArr
      },
      handleSizeChange (val) {
        this.pageSize = val
        this.init()
      },
      handleCurrentChange (val) {
        this.page = val
        this.init()
      }
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  .manage {
    padding: 16px;
  }
  </style>
  